// ** React Imports
import { lazy } from 'react'

const LoanKeyIndex = lazy(() => import('../../views/loankeys/list'))

const LoanKey = [
  {
    path: '/loankey/list',
    element: <LoanKeyIndex/>
  }
]

export default LoanKey
